<template>
  <component
    :is="to ? 'router-link' : href ? 'a' : 'div'"
    :to="to"
    :exact="!!to && to.includes('?')"
    v-bind="customAttrs"
    class="v-list__tile v-list__tile--link v-list__tile--menuc"
    :class="{ 'drawer-link--current': isCurrent }"
    active-class="drawer-route-active"
    :aria-current="isCurrent ? 'page' : null"
    v-on="$listeners"
  >
    <v-list-tile-avatar v-if="avatar" :color="avatarColor">
      <v-icon dark v-text="avatar" />
    </v-list-tile-avatar>
    <v-list-tile-action v-else-if="icon">
      <v-icon v-text="icon" aria-hidden="true" />
    </v-list-tile-action>
    <v-list-tile-content>
      <v-list-tile-title> <span v-text="text" /> </v-list-tile-title>
      <v-list-tile-sub-title v-if="subtext">
        <span v-text="subtext" />
      </v-list-tile-sub-title>
    </v-list-tile-content>
    <v-chip v-if="chip" :color="chipColor" class="v-chip--x-small" dark>{{
      chip
    }}</v-chip>
    <slot />
  </component>
</template>

<script>
import { isMenuLinkActive } from '@/helpers/Navigation'
export default {
  inheritAttrs: false,
  props: {
    avatar: {
      type: String,
      default: undefined,
    },
    avatarColor: {
      type: String,
      default: undefined,
    },
    text: {
      type: String,
      default: '',
    },
    href: {
      type: String,
      default: undefined,
    },
    name: {
      type: String,
      default: '',
    },
    icon: {
      type: [Boolean, String],
      default: false,
    },
    chip: {
      type: String,
      default: '',
    },
    subtext: {
      type: String,
      default: undefined,
    },
    to: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      chipMap: {
        new: 'primary',
        updated: 'warning',
        deprecated: 'black',
      },
    }
  },
  computed: {
    isCurrent() {
      return isMenuLinkActive(this.to, this.$route)
    },
    chipColor() {
      return this.chipMap[this.chip]
    },
    customAttrs() {
      const attrs = {
        ...this.$attrs,
      }
      if (this.href) {
        attrs.target = '_blank'
        attrs.rel = 'noopener'
        attrs.href = this.href
      }
      return attrs
    },
    path() {
      if (!this.to) return this.to
      const lang = this.$route.params.lang || this.$i18n.fallbackLocale
      return {
        path: `/${lang}/${this.to}`,
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
/* Estilos visuales del drawer viven en AppDrawer.vue (con /deep/) para
 * mantener una sola fuente de verdad. Aquí solo hooks neutrales. */
.v-list__tile--menuc
  transition: background .15s ease

  .v-list__tile__title span
    font-size: 14px
    font-weight: 400
</style>
